import { GridItem, FormControl, FormErrorMessage } from '@chakra-ui/react'
import { FieldError } from 'react-hook-form'
import OutlineLabel from './OutlineLabel'

interface CustomCheckboxProps {
  customColSpan?: number
  customRowSpan?: number
  error?: FieldError | undefined
  children?: React.ReactNode
  title?: string | ''
}

const CustomInputForm: React.FC<CustomCheckboxProps> = ({ customColSpan, customRowSpan, error, children, title }) => {
  const defaultColSpan = 2
  const colSpan = customColSpan || defaultColSpan

  const defaultRowSpan = 1
  const rowSpan = customRowSpan || defaultRowSpan
  const defaultTitle = title || ''
  return (
    <>
      <GridItem
        colSpan={colSpan}
        rowSpan={rowSpan}
        children={
          <FormControl isInvalid={!!error}>
            <OutlineLabel name={defaultTitle} id={defaultTitle.toLowerCase()} />
            {children}
            <FormErrorMessage children={error?.message} />
          </FormControl>
        }
      />
    </>
  )
}

export default CustomInputForm
